<template>
  <div>
    <div
      v-if="showLoader && social.length === 0"
      class="d-flex align-center"
      style="min-height: 80vh"
    >
      <v-progress-circular
        v-if="showLoader"
        class="mx-auto"
        indeterminate
        color="#72AFE7"
      ></v-progress-circular>
    </div>
    <v-row>
      <v-col
        cols="6"
        md="3"
        xl="3"
        lg="3"
        sm="4"
        v-for="social in social"
        :key="social.id"
      >
        <v-hover v-slot="{ hover }" open-delay="200">
          <v-card
            class="my-3"
            :disabled="social.status == 'InActive'"
            :to="'socials/edit/' + social.uid + '/info'"
            :elevation="hover ? 16 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-img height="160" v-bind:src="social.logo" v-if="social.logo" />
            <v-img height="160" src="@/assets/IoP.png" v-else />
            <v-card-title>{{ social.name }}</v-card-title>
            <v-card-text class="px-2">
              <v-row>
                <v-col class="col-1 mr-2 col_">
                  <span>
                    <VIcon color="#72AFE7">mdi-map-marker</VIcon>
                  </span>
                </v-col>
                <v-col class="col_ overflow-ellipsis">
                  <span
                    class="d-inline-block text-truncate"
                    :style="
                      $vuetify.breakpoint.xs
                        ? 'max-width: 110px'
                        : $vuetify.breakpoint.sm
                        ? 'max-width: 180px'
                        : 'max-width: 200px'
                    "
                  >
                    {{ social.address }}
                  </span>
                </v-col>
              </v-row>
              <v-row justify="center" align="center" class="mb-2">
                <div>
                  <h3>{{ "is_public" | localize }}: {{ social.is_public }}</h3>
                </div>
              </v-row>
              <v-row v-if="$vuetify.breakpoint.xs">
                <v-col class="col_">
                  <span>{{ "business_rating" | localize }}</span>
                </v-col>
                <v-col class="text-right col_">
                  <VIcon color="#ECBD16" class="mb-1" small>mdi-star</VIcon>
                  <span>{{ social.rating }}</span>
                </v-col>
              </v-row>
              <div v-else>
                <v-row class="mt-3 justify-center">
                  <div class="justify-center">
                    <span
                      ><strong>{{ "business_rating" | localize }}</strong></span
                    >
                  </div>
                </v-row>
                <v-row class="mb-1" justify="center">
                  <div>
                    <v-rating
                      v-model="social.rating"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      half-increments
                      hovers
                      dense
                      readonly
                    />
                  </div>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SocialService from "@/requests/Socials/SocialService";
export default {
  data: () => ({
    social: [],
    showLoader: true,
  }),
  mounted() {
    this.getSocial();
  },
  methods: {
    async getSocial() {
      let response = await SocialService.getAllSocial();
      this.social = response.result;
      console.log(response.result);
      if (response.result.length === 0) {
        this.$router.push({ name: "addSocials" });
      }
      this.$emit("checkHoozies", response.result);
      this.showLoader = false;
    },
  },
};
</script>

<style>
.v-card--disabled {
  pointer-events: unset !important;
}
</style>